
    // let isAnimating = false;
    
    
    // $('.levo-gr-one__tab[data-levo-tab]').on('click', function() {
    //     if (isAnimating) return; //Prevent multiple clicks
        
    //     const tabIndex = $(this).data('levo-tab');
    //     const $clickedTab = $(this);
        
    //     if ($clickedTab.hasClass('levo-gr-one__tab--active')) return;
        
    //     isAnimating = true;
        
        
    //     $('.levo-gr-one__image-container').addClass('levo-gr-one__image-container--loading');
        
     
    //     $('.levo-gr-one__tab-content--active').fadeOut(200, function() {
    //         // Remover clase activa de todos los tabs
    //         $('.levo-gr-one__tab').removeClass('levo-gr-one__tab--active');
            
    //         // Agregar clase activa al tab clickeado
    //         $clickedTab.addClass('levo-gr-one__tab--active');
            
    //         // Remover clase activa de todo el contenido
    //         $('.levo-gr-one__tab-content').removeClass('levo-gr-one__tab-content--active');
            
    //         // Mostrar el nuevo contenido con animación
    //         const $newContent = $(`.levo-gr-one__tab-content[data-levo-content="${tabIndex}"]`);
    //         $newContent.addClass('levo-gr-one__tab-content--active');
             
    //         // Fade in del nuevo contenido
    //         $newContent.hide().fadeIn(300, function() {
    //             // Remover efecto shimmer
    //             $('.levo-gr-one__image-container').removeClass('levo-gr-one__image-container--loading');
    //             isAnimating = false;
    //         });
    //     });
        
    //     // Efecto visual en el tab clickeado
    //     $clickedTab.css('transform', 'scale(0.95)');
    //     setTimeout(() => {
    //         $clickedTab.css('transform', '');
    //     }, 150);
    //     isAnimating = false;
    //     // Agregar efecto de ondas (ripple effect)
    //     createRippleEffect($clickedTab, event);
    // });
    
    // // Función para crear efecto de ondas
    // function createRippleEffect($element, event) {
    //     const $ripple = $('<span class="ripple"></span>');
    //     const elementRect = $element[0].getBoundingClientRect();
    //     const size = Math.max(elementRect.width, elementRect.height);
    //     const x = event.clientX - elementRect.left - size / 2;
    //     const y = event.clientY - elementRect.top - size / 2;
        
    //     $ripple.css({
    //         width: size + 'px',
    //         height: size + 'px',
    //         left: x + 'px',
    //         top: y + 'px'
    //     });
        
    //     $element.css('position', 'relative').css('overflow', 'hidden').append($ripple);
        
    //     setTimeout(() => {
    //         $ripple.remove();
    //     }, 600);
    // }
  
    // // Navegación por teclado mejorada
    // $('.levo-gr-one__tab[data-levo-tab]').on('keydown', function(e) {
    //     if (e.key === 'Enter' || e.key === ' ') {
    //         e.preventDefault();
    //         $(this).click();
    //     }
        
    //     // Navegación con flechas
    //     if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
    //         e.preventDefault();
    //         const $tabs = $('[data-levo-tab]');
    //         const currentIndex = $tabs.index(this);
    //         let newIndex;
            
    //         if (e.key === 'ArrowLeft') {
    //             newIndex = currentIndex > 0 ? currentIndex - 1 : $tabs.length - 1;
    //         } else {
    //             newIndex = currentIndex < $tabs.length - 1 ? currentIndex + 1 : 0;
    //         }
            
    //         $tabs.eq(newIndex).focus().click();
    //     }
    // });
    
    $(document).ready(function () {
  // Mostrar por defecto el primer tab
  $('.levo-gr-one__tab[data-levo-tab="0"]').addClass('levo-gr-one__tab--active');
  $('.levo-gr-one__tab-content[data-levo-content="0"]').show().addClass('levo-gr-one__tab-content--active');

  var previousLevoTab = 0;

  function handleLevoTabClick(tabClicked) {
    if (tabClicked != previousLevoTab) {
  // Oculta TODOS los contenidos (instrucciones + imagen)
$('.levo-gr-one__tab-content[data-levo-content]').hide().removeClass('levo-gr-one__tab-content--active');

// Muestra solo los contenidos con el índice seleccionado (instrucción + imagen)
$(`.levo-gr-one__tab-content[data-levo-content="${tabClicked}"]`).fadeIn().addClass('levo-gr-one__tab-content--active');

      // Actualizar clases activas en tabs
      $('.levo-gr-one__tab').removeClass('levo-gr-one__tab--active');
      $(`.levo-gr-one__tab[data-levo-tab="${tabClicked}"]`).addClass('levo-gr-one__tab--active');

      previousLevoTab = tabClicked;

      
    } 
  }

  // Evento para botones (tabs)
  $('.levo-gr-one__tab').on('click keypress', function (event) {
    if ((event.type === 'keypress' && event.which === 13) || event.type === 'click') {
      const tabClicked = $(this).data('levo-tab');
      handleLevoTabClick(tabClicked);
    }
  });

  // Evento en mobile para el tab completo
  $('.levo-gr-one__tab').on('touchstart', function () {
    if (window.innerWidth <= 768) {
      const tabClicked = $(this).data('levo-tab');
      handleLevoTabClick(tabClicked);
    }
  });
});
